import { apiClient } from '@/shared/api';
import type { EmployeeCreateRequest, EmployeeResponse, EmployeeUpdateRequest } from '../types';

/**
 * Создание сотрудника POST /employee
 * Требуется разрешение ADMIN_EMPLOYEE
 */
export const createEmployee = async (body: EmployeeCreateRequest): Promise<EmployeeResponse> => {
  const { data } = await apiClient.post<EmployeeResponse>('/employee', body);
  return data;
};

/**
 * Обновление сотрудника PUT /employee/{id}
 * Требуется разрешение ADMIN_EMPLOYEE
 */
export const updateEmployee = async (id: number, body: EmployeeUpdateRequest): Promise<EmployeeResponse> => {
  const { data } = await apiClient.put<EmployeeResponse>(`/employee/${id}`, body);
  return data;
};

/**
 * Удаление сотрудника DELETE /employee/{id}?employeeId={targetEmployeeId}
 * Требуется разрешение ADMIN_EMPLOYEE
 */
export const deleteEmployee = async (id: number, targetEmployeeId: number): Promise<void> => {
  await apiClient.delete(`/employee/${id}`, { params: { employeeId: targetEmployeeId } });
};

/**
 * Объединение дубликатов сотрудника POST /employee/{id}/merge
 * Требуется разрешение ADMIN_EMPLOYEE
 */
export const mergeEmployee = async (id: number): Promise<void> => {
  await apiClient.post(`/employee/${id}/merge`);
};
